import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import HR from '../elements/HR';

const getClasses = (className = UIDropdownDivider.defaultProps.className) => classNames('private-dropdown-divider', className);

export default function UIDropdownDivider(_ref) {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/_jsx(HR, Object.assign({
    distance: "xs"
  }, rest, {
    className: getClasses(className)
  }));
}
UIDropdownDivider.displayName = 'UIDropdownDivider';
UIDropdownDivider.defaultProps = {
  className: ''
};